import React, { useState, useEffect } from 'react';
import ContratoEditor from './ContratoEditor';
import { connect } from 'react-redux';
import {
  getAllByParent,
  setPending,
  deleted,
} from '../redux/actions/contratoActions';
import { callStatus } from '../utils/constants';
import { Button, Space, Layout, Modal, Tag } from 'antd';
import { withRouter } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import {
  EditFilled,
  DeleteFilled,
  PlusCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import MetaTable from './base/MetaTable';
import dayjs from 'dayjs';
import { convertDate } from '../utils/funtions';
import CustomCellRender from './base/CustomCellRender';
const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;
const ContratoList = ({
  location,
  stateData,
  inversor,
  formaPagoContrato,
  dispatch,
  match: {
    params: { id, id2 },
  },
  parent,
  configuracion,
}) => {
  const isInversorUnico =
    configuracion?.list?.data?.find((c) => c.nombre === 'inversor_unico')
      ?.valor === '1';

  const [showEdit, setShowEdit] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const history = useHistory();
  useEffect(() => {
    dispatch(getAllByParent(id2));
    dispatch(setPending());
    // eslint-disable-next-line
  }, []);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const handleCuotas = (data) => {
    history.push(`/campanas/${id}/alquileres/${id2}/contratos/${data.id}`);
  };

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 60,
    },
    {
      width: 120,
      ellipsis: true,
      title: 'Número',
      dataIndex: 'numero',
      render: (text, record) => (
        <span className="hover-bold-link" onClick={() => handleCuotas(record)}>
          {text}
        </span>
      ),
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Fecha',
      dataIndex: 'fecha',
      render: (text) =>
        text ? dayjs(convertDate(text)).format('DD/MM/YYYY') : '',
    },

    {
      width: 200,
      ellipsis: true,
      title: 'Modalidad Pago',
      dataIndex: 'forma_pago',
      render: (text, record) => record.forma_pago?.nombre,
      onFilter: (value, record) => {
        return record.forma_pago_id === value;
      },
      sorter: (a, b) =>
        a.forma_pago?.nombre?.localeCompare(b.forma_pago?.nombre),
      filterMultiple: true,
      filters: formaPagoContrato.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Superficie Ha',
      dataIndex: 'superficie',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Toneladas',
      dataIndex: 'toneladas',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Toneladas Totales',
      dataIndex: 'toneladas_total',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Importe U$D',
      dataIndex: 'importe',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 200,
      ellipsis: true,
      title: 'Propietario',
      dataIndex: 'propietario',
      render: (text, record) =>
        record.alquiler_propietario?.propietario?.nombre,
    },
    {
      ellipsis: true,
      title: 'Aportante',
      dataIndex: 'inversor',
      render: (text, record) => {
        if (isInversorUnico) {
          return record.inversor?.nombre;
        } else {
          if (
            record.contrato_inversores &&
            record.contrato_inversores.length > 0
          ) {
            return (
              <>
                {record.contrato_inversores.map((inv) => (
                  <Tag color="blue" key={inv.inversor_id}>
                    {inv.inversor?.nombre || inv.inversor_nombre} (
                    {inv.porcentaje}%)
                  </Tag>
                ))}
              </>
            );
          }
          return record.inversor?.nombre;
        }
      },
      onFilter: (value, record) => {
        return record.inversor_id === value;
      },
      sorter: (a, b) => a.inversor?.nombre?.localeCompare(b.inversor?.nombre),
      filterMultiple: true,
      filters: inversor.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
    },
  ];
  return (
    <Layout style={{ height: '100%' }}>
      <Header></Header>
      <Content>
        <MetaTable
          dataSource={stateData.list.data}
          dataColumns={columns}
          bordered={false}
          selection={false}
          loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
        />
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar Contrato
            </Button>
          </ActionsContainer>
        </FooterContainer>
      </Footer>
      {showEdit ? (
        <ContratoEditor
          id={rowEdit.id}
          parentId={id2}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { contrato, inversor, formaPagoContrato, alquiler, configuracion } =
    state;
  const stateData = contrato;
  const parent = alquiler;

  return {
    stateData,
    inversor,
    formaPagoContrato,
    parent,
    configuracion,
  };
};
export default connect(mapStateToProps)(withRouter(ContratoList));
